import { api, throwBlobErrorAsJson } from "@/services/api";

export const audioEnhancementApi = {
  async process(file: File): Promise<Blob> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api
      .post("/audio-enhancement", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      })
      .catch(throwBlobErrorAsJson);

    return response.data as Blob;
  },
};
